import { CircularProgress, Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import '../../../scss/UVP.scss';
import { PaymentChannel, TokenType } from '../../../services/V2/gozer';
import { formatMoney, handleErrorToast } from '../../shared/Functions';
import { PaymentsVService, PaymentTypeEnum } from '../../../services/V3/longhorn';
import { TokensVService } from '../../../services/V3/gozer';

export const PaymentFlowPage2 = ({
    errorToast,
    billingAccount,
    paymentToken,
    cancel,
    amount,
    selectedTab,
    setSelectedTab,
    hasError,
    newPayment,
    newEmail,
    setPaymentMade,
    setMainFee
}) => {
    const [loading, setLoading] = useState<boolean>(false);
    const [nextDisabled, setNextDisabled] = useState<boolean>(true);
    const [fee, setFee] = useState<any>(0);

    useEffect(() => {
        if ((selectedTab === 0 && !hasError && (paymentToken || newPayment?.ach)) || selectedTab !== 0)
            setNextDisabled(false);
        else setNextDisabled(true);
    }, [paymentToken, newPayment, hasError])// eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setLoading(true)
        PaymentsVService.paymentsVGetServiceFee(
            billingAccount.districtId,
            paymentToken?.tokenType === TokenType.CC ? PaymentTypeEnum.CC : PaymentTypeEnum.ACH,
            amount,
            paymentToken?.cardType
            
        )
            .then(x => {
                setFee(x)
                setMainFee(x)
                setLoading(false)
            })
            .catch(x => handleErrorToast(x) !== "No Service Fees Found" ? errorToast(handleErrorToast(x)) : setLoading(false))
    }, [])// eslint-disable-line react-hooks/exhaustive-deps

    const back = () => {
        setSelectedTab(selectedTab - 1)
    }

    const next = () => {
        if (paymentToken || newPayment?.ach) {
            setLoading(true)
            TokensVService.tokensVCharge(billingAccount.id, paymentToken.id, {
                channel: PaymentChannel.ONE_TIME_PAYMENT,
                amount: amount
            })
                .then(t => {
                    setPaymentMade(t);
                    setSelectedTab(selectedTab + 1)
                    setLoading(false)
                })
                .catch(err => {
                    errorToast(handleErrorToast(err))
                    setPaymentMade({
                        error: handleErrorToast(err)
                    })
                    setLoading(false)
                });
        }
    }

    return (
        <React.Fragment>
            <Grid container style={{ height: "465px" }}>
                <Grid item xs={5} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Account</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={billingAccount?.accountNumber} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Name</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={billingAccount?.customer.fullName} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Receipt Delivery Email</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={billingAccount?.customer?.email ?? newEmail} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Payment Method</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={paymentToken && paymentToken?.id !== "CCTerminal" ? (`${paymentToken.tokenType === TokenType.CC ?
                                paymentToken.cardType : `${paymentToken.achAccountHolderType} ${paymentToken.achType}`} ****${paymentToken.last4}`) : "Terminal"} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Payment Date</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={(new Date()).toLocaleDateString()} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Payment Amount</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" defaultValue={formatMoney(amount)} disabled={true} />
                        </label>
                    </div>
                    <div style={{ display: "flex" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Service Fee</b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" value={formatMoney(fee)} disabled={true} />
                        </label>
                    </div>
                </Grid>
                <Grid item xs={6} style={{ display: "flex", flexDirection: "column", alignItems: "flex-end" }}>
                    <div style={{ display: "flex", justifyContent: "flex-end", marginRight: "5px" }}>
                        <label className='uvp-label' style={{ marginTop: "20px" }}>
                            <b>Total Amount </b><span>&nbsp;:&nbsp;</span>
                            <input className='uvp-input' style={{ width: "250px" }} type="text" value={formatMoney(parseFloat(amount) + parseFloat(fee.toString()))} disabled={true} />
                        </label>
                    </div>
                    <Grid container style={{ display: "flex", justifyContent: "flex-end", margin: "30px 0px 40px 0px" }}>
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button onClick={next} disabled={nextDisabled} className={"green-button uvp-button"}
                                style={{
                                    marginRight: "10px",
                                    padding: "5px 10px",
                                    width: "250px"
                                }}>
                                Submit
                            </button>
                        </Grid>
                        <Grid item xs={12} style={{ display: "flex", justifyContent: "flex-end" }}>
                            <button onClick={async () => back()} className={"gray-button uvp-button"}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                    width: "120px"
                                }}>
                                Back
                            </button>
                            <button onClick={async () => cancel()} className={"gray-button uvp-button"}
                                style={{
                                    margin: "10px",
                                    padding: "5px 10px",
                                    width: "120px"
                                }}>
                                Cancel
                            </button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            {loading &&
                <div className='loading-container'><CircularProgress color="primary" className='center-spinner' /></div>
            }
        </React.Fragment>
    )
}